import { GetDisputeConfigDTO } from "@/core/dto/deduction/disputeDeduction";
import {
  DISPUTE_REQUIRED_FIELD_LABELS,
  DisputeRequiredDataInput,
  formatMissingDisputeFieldsMessage,
  getMissingDisputeRequiredFields,
} from "@/core/entities/deduction/dispute/validateDisputeRequiredData";
import { IDeductionDisputeRepository } from "@/core/repositories/deduction";

export interface ValidateDisputeReadinessParams {
  deductionId: number;
  remittanceItemId: number;
  purchaserKey: string;
  purchaserId: number;
  deductionTypeId: number;
  checkNumber: string;
  invoiceNumber: string;
  deductionAmount: number | null | undefined;
  remittanceNetAmount: number | null | undefined;
  backupDocumentCount: number;
}

export interface ValidateDisputeReadinessResult {
  isReady: boolean;
  missingFieldLabels: string[];
  message: string;
}

export class ValidateDisputeReadinessUseCase {
  constructor(private readonly disputeRepository: IDeductionDisputeRepository) {}

  async execute(params: ValidateDisputeReadinessParams): Promise<ValidateDisputeReadinessResult> {
    const response = await this.disputeRepository.getDisputeConfig(
      new GetDisputeConfigDTO({
        purchaserId: params.purchaserId,
      })
    );

    const isDocumentsRequired =
      response.disputeConfig.isDocumentsRequiredConfig.find(config => config.deductionTypeId === params.deductionTypeId)
        ?.isDocumentsRequired ?? false;

    const validationInput: DisputeRequiredDataInput = {
      ...params,
      isDocumentsRequired,
    };

    const missingKeys = getMissingDisputeRequiredFields(validationInput);
    const missingFieldLabels = missingKeys.map(key => DISPUTE_REQUIRED_FIELD_LABELS[key]);

    return {
      isReady: missingKeys.length === 0,
      missingFieldLabels,
      message: formatMissingDisputeFieldsMessage(missingKeys),
    };
  }
}
